module.exports = __webpack_public_path__ + "static/media/tesla_car_mobile.7fe26d71.png";